import { render, staticRenderFns } from "./AdminCatalogueDetails.vue?vue&type=template&id=18075b44&"
import script from "./AdminCatalogueDetails.vue?vue&type=script&lang=ts&"
export * from "./AdminCatalogueDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports